import config from "config/config";
import { getToken } from "js/formatting/getToken";

export async function getDisabilityClaims(policies) {
  let policieWithDisabilityClaims = policies.filter(
    (p) => p.IsDisabilityClaimExist
  );
  let disabilityClaimsData = [];
  if (policieWithDisabilityClaims?.length > 0) {
    let contractIds = policieWithDisabilityClaims.map((p) => p.contractID);
    let options = {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "Ocp-Apim-Subscription-Key": config.ODS_API_KEY,
        Authorization: `bearer ${getToken()}`,
      },
      body: JSON.stringify({
        contractIds: contractIds,
      }),
    };

    const response = await fetch(
      config.REG_API_BASE_URL + "/user/policylistdetail",
      options
    );
    if (!response.ok) {
      throw response;
    } else {
      const data = await response.json();
      if (data?.length > 0) {
        data.forEach((policy) => {
          let policyDetails = JSON.parse(policy?.policyDetails);
          let selectedPolicy =
            policyDetails.gXdpApi.gIdpPayLoad.policyHolder.policies[0];
          if (selectedPolicy?.disabilityClaim?.length > 0) {
            selectedPolicy?.disabilityClaim.map((dClaim) => {
              disabilityClaimsData.push({
                claimStatus: dClaim.claimStatus,
                claimType: dClaim.claimType,
                oldPolicy: selectedPolicy.oldPolicy,
                dateReceived: dClaim.claimOpenedDate,
                claimNumber: dClaim?.claimNumber,
                contractID: selectedPolicy.contractID,
              });
            });
          }
        });
      }
      return disabilityClaimsData;
    }
  }
  return disabilityClaimsData;
}
